import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import { Division } from '../../../components'
import StatsChart from './StatsChart'

const useStyles = makeStyles((theme) => ({
  container: {
    alignContent: 'center',
  },
  solidBox: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    margin: '3px 0',
    width: '100%',
  },
  formControl: {},
  selectInput: {
    paddingTop: 7,
    paddingBottom: 7,
    paddingRight: '42px !important',
    backgroundColor: 'white',
    fontWeight: 600,
    color: theme.palette.secondary.main,
  },
  statNumber: {
    fontSize: 75,
    [theme.breakpoints.down('sm')]: {
      fontSize: 60,
    },
    fontWeight: 900,
    color: theme.palette.secondary.main,
  },
  statPostText: {
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
    color: theme.palette.secondary.main,
  },
  statConstituency: {
    fontSize: 32,
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
    marginTop: -5,
  },
}))
const gridConfig = { xs: 12, md: 6, lg: 4, direction: 'column', alignItems: 'center' }

const SectionLocationStats = ({ results, width }) => {
  const desktop = isWidthUp('md', width)
  const classes = useStyles()

  const getStats = (constituency) => {
    const latestNumber = Number(
      constituency.poverty_stats.number_201920 || constituency.poverty_stats.number_201819
    ).toLocaleString('en-GB')
    const latestPerc = Number(
      constituency.poverty_stats.percentage_201920 ||
        constituency.poverty_stats.percentage_201819
    ).toLocaleString('en-GB', { style: 'percent' })

    return (
      <Grid item container {...gridConfig}>
        <Grid item>
          <Typography variant="body1">Your constituency</Typography>
        </Grid>
        <Grid item>
          <Typography variant="h5" align="center" className={classes.statConstituency}>
            {results.constituency.name}
          </Typography>
        </Grid>
        <Grid item>
          <Division padding={10} />
        </Grid>
        <Grid item>
          <Typography variant="h1" className={classes.statNumber}>
            {latestNumber}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h5" align="center" className={classes.statPostText}>
            {'Children are trapped in poverty'}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" align="center" className={classes.statPostText}>
            {`That’s ${latestPerc} of children in ${results.constituency.name}`}
          </Typography>
        </Grid>
      </Grid>
    )
  }

  const getChart = () => (
    <Grid item>
      <StatsChart stats={results?.constituency?.poverty_stats} />
    </Grid>
  )

  return (
    !!results &&
    !_.isEmpty(results) && (
      <Grid
        container
        // direction={desktop ? 'row' : 'column'}
        className={classes.container}
        justify="center"
        alignItems="center"
        spacing={2}
      >
        {desktop ? getChart() : getStats(results.constituency)}
        {desktop ? getStats(results.constituency) : getChart()}
      </Grid>
    )
  )
}

export default withWidth()(SectionLocationStats)
